import i, { createContext as l, useContext as d } from "react";
import { useIsoMorphicEffect as m } from "../hooks/use-iso-morphic-effect.js";
import { useEvent as p } from "../hooks/use-event.js";
var o = l(function () {});
o.displayName = "StackContext";

var f = function (e) {
  return e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e;
}(f || {});

function x() {
  return d(o);
}

function C(_ref) {
  var u = _ref.children,
      r = _ref.onUpdate,
      e = _ref.type,
      n = _ref.element;
  var c = x(),
      t = p(function () {
    r == null || r.apply(void 0, arguments), c.apply(void 0, arguments);
  });
  return m(function () {
    return t(0, e, n), function () {
      return t(1, e, n);
    };
  }, [t, e, n]), i.createElement(o.Provider, {
    value: t
  }, u);
}

export { f as StackMessage, C as StackProvider, x as useStackContext };